import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-results-footer',
  imports: [NgTemplateOutlet, RmaIconComponent, TranslocoModule],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsFooterComponent {
  @Input()
  canShowMore: boolean | null = false;

  @Output()
  happy = new EventEmitter<void>();

  @Output()
  showMore = new EventEmitter<void>();
}
